import React from 'react';

import NumberFlow from '@number-flow/react';
import { capitalize } from 'lodash/fp';

import TokenImg from '@/components/TokenImg/TokenImg';
import { Currency, NATIVE_TOKEN_TYPE } from '@/constants';
import { useWallet } from '@/hooks/useWallet';
import { calculatePrecisionNumberStats } from '@/utils';

import HeaderWalletDrawerBalancesInfoBadges from '../HeaderWalletDrawerBalancesInfoBadges';

interface HeaderWalletDrawerBalanceCardCwebProps {
  shouldHideSmallBalances?: boolean;
}

const HeaderWalletDrawerBalanceCardCweb: React.FC<HeaderWalletDrawerBalanceCardCwebProps> = ({
  shouldHideSmallBalances,
}) => {
  const currency = Currency.CWEB;
  const wallet = useWallet(currency);

  if (!wallet.isConnected) {
    return null;
  }

  const balanceToken = calculatePrecisionNumberStats(wallet.balanceToken, currency, 8).amountWithPrecision;

  const isHidden = Boolean(shouldHideSmallBalances) && Number(wallet.balanceUsd) < 0.1;
  if (isHidden) return null;

  return (
    <div
      className="text-primary bg-background/60 hover:bg-background/80 flex w-full shrink-0 items-center gap-2
        overflow-hidden rounded-xl p-2.5 text-base sm:px-2.5 md:px-4"
    >
      <div className="flex size-12 flex-col items-center justify-center">
        <TokenImg token={currency} className="size-8" />
      </div>
      <div className="flex w-full flex-row justify-between">
        <div className="flex w-full flex-col">
          <div className="flex flex-row items-center justify-between font-bold">
            <div className="flex items-center gap-1">{currency}</div>
            <div>
              <NumberFlow value={Number(balanceToken)} format={{ maximumFractionDigits: 8 }} />
            </div>
          </div>
          <div className="text-muted-foreground flex flex-row items-center justify-between text-[13px] leading-tight">
            <div>
              Coinweb - <HeaderWalletDrawerBalancesInfoBadges items={[capitalize(NATIVE_TOKEN_TYPE), 'Layer2']} />
            </div>
            <div>
              <NumberFlow value={Number(wallet.balanceUsd)} prefix="$ " format={{ minimumFractionDigits: 2 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderWalletDrawerBalanceCardCweb;
